import React, { Fragment, useEffect } from 'react'

export default function FormItem({children,onRegister}) {
    useEffect(() => {
        onRegister();
    }, []);
  return (
    <Fragment>
        {children}
    </Fragment>
  )
}
